import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enarocanje',
  templateUrl: './enarocanje.component.html',
  styles: []
})
export class EnarocanjeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
